import { isEmpty } from 'lodash'

// `selectedInput` is the DB column name to filter on, coming from
// searchDropDownOptionMapping.privateOffersOptionMapping ('company_name' or
// 'aws_offer_id'). Maps it to the explicit query param getPrivateOffersData expects.
export const getPrivateOffersSearchParams = (
  input?: string,
  selectedInput?: string
) => {
  if (isEmpty(input)) {
    return {}
  }
  switch (selectedInput) {
    case 'aws_offer_id':
      return { awsOfferId: input }
    case 'company_name':
      return { companyName: input }
    default:
      return {}
  }
}
